import {
  BIBME,
  CHEGG,
  CITATION_MACHINE,
  EASYBIB,
  GtmConfig,
  SiteConfig,
  SiteState,
} from './types'

export const supportPageLinks = {
  easybib: 'https://www.chegg.com/contactus/easybibsupport',
  citationmachine: 'https://www.chegg.com/contactus/citationmachinesupport',
  chegg: '//www.chegg.com/contactus/#/path/',
  citethisforme: 'https://www.chegg.com/contactus/citethisformesupport',
  bibme: 'https://www.chegg.com/contactus/bibmesupport',
}

const EASYBIB_GTM_ID = 'GTM-MS6L4L'
const BIBME_GTM_ID = 'GTM-T425DXK'
const CITATION_MACHINE_GTM_ID = 'GTM-PR4ZBX'
const CHEGG_GTM_ID = 'GTM-MWT3Q4H'
const OPTIMIZELY_PROJECT_ID = '17022043465'

const gtmPlaygroundConfig: GtmConfig = {
  [EASYBIB]: {
    gtmId: EASYBIB_GTM_ID,
    auth: 'ijnOcow8ACpYkpLR_gjVQg',
    preview: 'env-28',
  },
  [BIBME]: {
    gtmId: BIBME_GTM_ID,
    auth: 'AhFxIClGhip6izLzfqdcRg',
    preview: 'env-25',
  },
  [CITATION_MACHINE]: {
    gtmId: CITATION_MACHINE_GTM_ID,
    auth: '0cCQhrRWGSHePFDvjXde_w',
    preview: 'env-32',
  },
  [CHEGG]: {
    gtmId: CHEGG_GTM_ID,
    auth: 'ZzK-BnEPcut3aJvcc8_02w',
    preview: 'env-101',
  },
}

const gtmProdConfig: GtmConfig = {
  [EASYBIB]: {
    gtmId: EASYBIB_GTM_ID,
    auth: 'AOO25YALJCllgEc5iFZOSQ',
    preview: 'env-1',
  },
  [BIBME]: {
    gtmId: BIBME_GTM_ID,
    auth: '6AOkD-IR-1RLHKRIRA8b7Q',
    preview: 'env-2',
  },
  [CITATION_MACHINE]: {
    gtmId: CITATION_MACHINE_GTM_ID,
    auth: 'S4n_BGrW5rrjm6vmQeG8yQ',
    preview: 'env-1',
  },
  [CHEGG]: {
    gtmId: CHEGG_GTM_ID,
    auth: 'IYUGV95zMJkGi2EOs09Ufg',
    preview: 'env-2',
  },
}

const saps = {
  [EASYBIB]: 'EB',
  [BIBME]: 'BM',
  [CITATION_MACHINE]: 'CM',
  [CHEGG]: 'CW',
}

export const defaultSAVersion = '2.124.*'
export const cWPlaygroundSAVersion = '2.124.*'

export const tld = {
  [EASYBIB]: 'com',
  [BIBME]: 'org',
  [CITATION_MACHINE]: 'net',
  [CHEGG]: 'com',
}

const trialLink = {
  [EASYBIB]: 'terms-and-conditions/',
  [BIBME]: 'free-trial-terms-and-conditions/',
  [CITATION_MACHINE]: 'terms-and-conditions/',
  [CHEGG]: 'terms-and-conditions/',
}

const accountUrl = {
  [EASYBIB]: 'myaccount',
  [BIBME]: 'edit_account',
  [CITATION_MACHINE]: 'edit_account',
  [CHEGG]: 'insert account url here',
}
const basePlaygroundCookieDomains = (site: SiteState) =>
  ({
    [EASYBIB]: '.easybib.com',
    [BIBME]: '.bibme.org',
    [CITATION_MACHINE]: '.citationmachine.net',
    [CHEGG]: '.cheggnet.com',
  }[site])

const basePlaygroundOptimizelySdkKey = (site: SiteState) =>
  site === 'chegg' ? 'Wrm1ShQjJHp7FYJNHrqL2e' : 'WAPJcuh8j6DSwRxYW25HSx'

const baseOptimizelyProjectId = (site: SiteState) =>
  site === 'chegg' ? '16624190478' : OPTIMIZELY_PROJECT_ID

const baseProdCookieDomains = (site: SiteState) =>
  ({
    [EASYBIB]: '.easybib.com',
    [BIBME]: '.bibme.org',
    [CITATION_MACHINE]: '.citationmachine.net',
    [CHEGG]: '.chegg.com',
  }[site])

const capitalizedName = {
  [EASYBIB]: 'EasyBib',
  [BIBME]: 'BibMe',
  [CITATION_MACHINE]: 'Citation Machine',
  [CHEGG]: 'Chegg Writing',
}

const cheggAuthRedirectPlayground = (site: SiteState) => {
  return {
    [EASYBIB]:
      'https://auth-gate.playground.easybib.com/universal/login?brand=writing_easybib',
    [BIBME]: 'https://auth-gate.playground.bibme.org/universal/login?brand=writing_bibme',
    [CITATION_MACHINE]:
      'https://auth-gate.playground.citationmachine.net/universal/login?brand=writing_citationmachine',
    [CHEGG]: 'https://auth-gate.test.cheggnet.com/universal/login?brand=chegg',
  }[site]
}

const cheggAuthRedirectProd = (site: SiteState) => {
  return {
    [EASYBIB]: 'https://auth-gate.easybib.com/universal/login?brand=writing_easybib',
    [BIBME]: 'https://auth-gate.bibme.org/universal/login?brand=writing_bibme',
    [CITATION_MACHINE]:
      'https://auth-gate.citationmachine.net/universal/login?brand=writing_citationmachine',
    [CHEGG]: 'https://auth-gate.chegg.com/universal/login?brand=chegg',
  }[site]
}

export const termsLinkPlaygroundUrls = (site: SiteState) => {
  const terms = trialLink[site]
  return site === BIBME
    ? `https://www.bibme.org/${terms}`
    : `${cfePlaygroundConfig(site)}/${terms}`
}

export const termsLinkProdUrls = (site: SiteState) => {
  const terms = trialLink[site]
  return `${cfeProdConfig(site)}/${terms}`
}

const cfeProdConfig = (site: SiteState) =>
  site === CHEGG ? 'https://writing.chegg.com' : `https://www.${site}.${tld[site]}`

const cfePlaygroundConfig = (site: SiteState) =>
  site === CHEGG
    ? 'https://writing.test.cheggnet.com'
    : `https://playground.${site}.${tld[site]}`

const getCheckoutFeatureListEntryId = (site: SiteState) =>
  ({
    [CITATION_MACHINE]: '1M82l9Il61N4gYuMFp0M9R',
    [EASYBIB]: '25cwUFBGxU8pfNindkIROs',
    [CHEGG]: '3Ld45uoN0wTzET3Zy0i1w1',
    [BIBME]: '',
  }[site])

const baseConfig = (site: SiteState) => ({
  baseUrl: `${site}.${tld[site]}`,
  SAProfile: saps[site],
  helpUrl: supportPageLinks[site],
  capitalizedName: capitalizedName[site],
  contentfulSpace: 'zmin7pe4y74x',
  contentfulAccessToken: '0BSipSjoWubbBD3qY8RPivFpKuIhlRt2MSwn3FeZdWU',
  contentfulEnvironment: 'master',
  checkoutFeatureListEntryId: getCheckoutFeatureListEntryId(site),
  upgradeModalTitleExp: site === 'easybib',
})

const basePlaygroundEndpoints = (site: SiteState) => ({
  termsLink: termsLinkPlaygroundUrls(site),
  gtm: gtmPlaygroundConfig[site],
  cfeUrl: cfePlaygroundConfig(site),
  wbeUrl: `https://writing-backend.playground.${site}.${tld[site]}`,
  cheggAuthRedirect: cheggAuthRedirectPlayground(site),
  wssUrl: 'wss://wss.wtai.ezbib.com/test',
  accountUrl: `https://playground.${site}.${tld[site]}/${accountUrl[site]}`,
  wtaiUrl: 'https://test.wtai.ezbib.com',
  bffUrl: 'https://bff.writing.test.cheggnet.com/graphql',
  oneGraphUrl: 'https://gateway.test.cheggnet.com/one-graph/graphql',
  cheggSessionApiUrl: '//session-api.test3.cheggnet.com:6033/api/v1',
  cheggEnvUrl: 'https://trunk.live.test.cheggnet.com/',
  meBffUrl: 'https://gateway.test.cheggnet.com/me-web-bff/graphql',
})

const baseProdEndpoints = (site: SiteState) => ({
  termsLink: termsLinkProdUrls(site),
  gtm: gtmProdConfig[site],
  cfeUrl: cfeProdConfig(site),
  wbeUrl: `https://wbe-prod-api.${site}.${tld[site]}`,
  cheggAuthRedirect: cheggAuthRedirectProd(site),
  accountUrl: `https://www.${site}.${tld[site]}/${accountUrl[site]}`,
  wtaiUrl: 'https://wtai.easybib.com',
  bffUrl: 'https://bff.writing.chegg.com/graphql',
  oneGraphUrl: 'https://gateway.chegg.com/one-graph/graphql',
  cheggSessionApiUrl: '//session-api.prod.cheggnet.com:6033/api/v1',
  cheggEnvUrl: 'https://www.chegg.com/',
  meBffUrl: 'https://gateway.chegg.com/me-web-bff/graphql',
})

const playgroundConfig = (site: SiteState): SiteConfig => ({
  ...baseConfig(site),
  ...basePlaygroundEndpoints(site),
  cookieDomain: basePlaygroundCookieDomains(site),
  optimizelySdkKey: basePlaygroundOptimizelySdkKey(site),
  optimizelyProjectId: baseOptimizelyProjectId(site),
  dipApiKey: getPlaygroundDipApiKey(site),
  copyrightStartYear: getCopyrightStartYear(site),
  wfeReleaseTag: process.env.CI_COMMIT_SHA || '0.0.0',
})

const prodConfig = (site: SiteState): SiteConfig => ({
  ...baseConfig(site),
  ...baseProdEndpoints(site),
  cookieDomain: baseProdCookieDomains(site),
  optimizelySdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY as string,
  optimizelyProjectId: baseOptimizelyProjectId(site),
  dipApiKey: getProductionDipApiKey(site),
  copyrightStartYear: getCopyrightStartYear(site),
  wfeReleaseTag: process.env.REACT_APP_RELEASE_TAG || '0.0.0',
})

const getProductionDipApiKey = (site: SiteState): string =>
  ({
    [CITATION_MACHINE]:
      'SDRBUGltS0xZZVBnZUFaaWd1TEpZSExyQ3J2cnZkREI6UmQzUW5aTWU4eWUzTTNoOA==',
    [BIBME]: 'eEI5RGRadjBKNUJkZlk4Y1k1bElPU2ZSeXNpQWQ3N0g6WEdHd3lGUzRwOGhIQVRHYQ==',
    [EASYBIB]: 'aEI1OGJtdmlaQUFSa1RvS0JwNHRGQXg0Y203STJSQkE6alFYd080Y1psVWNkMW5zTA==',
    [CHEGG]: 'TnNZS3dJMGxMdVhBQWQwenFTMHFlak5UVXAwb1l1WDY6R09JZVdFRnVvNndRRFZ4Ug==',
  }[site])

const getCopyrightStartYear = (site: SiteState): string =>
  ({
    [CITATION_MACHINE]: '2000',
    [BIBME]: '2007',
    [EASYBIB]: '2001',
    [CHEGG]: '2003',
  }[site])

const siteConfig = (site: SiteState, pg: boolean) =>
  pg ? playgroundConfig(site) : prodConfig(site)

const getPlaygroundDipApiKey = (site: SiteState): string =>
  ({
    [EASYBIB]: 'bXpad1REbHpRQXpaS2o5QVpvR09PY0lXMUJGcFZxcE06M3pIempxSlJsZVpoeFJ6eg==',
    [BIBME]: 'SERuQ1dWZm54dXM4Tm5QY08wdER0b2VsS1RrOWdsWno6dUEzUWMzaXJobUMyUXlucg==',
    [CITATION_MACHINE]:
      'U3lCd0txRkdHRUFBVjYxdEJ2OGpWMVJlZFFFY0dTanc6eHVWcDdHSEU5bkxlRE81Uw==',
    [CHEGG]: 'cFZqcUljcDdtWUdOUnhUZWNCRm5FcFowdkp5SlJ5eXk6YVdydXBsbHI4VE9lc25wTA==',
  }[site])

export default siteConfig



// WEBPACK FOOTER //
// ./src/state/site/siteConfig.ts